module.exports = __webpack_public_path__ + "img/sponsor-icon.cef9a7cc.svg";